
global.foo = "foo";
global.bar = "bar";
global.curRecipe = null;
global.curProduct = null;


// WEBPACK FOOTER //
// ./src/global.js